// src/user/components/modals/SelfStartWorkflowModal.jsx
import React, { useEffect } from 'react';
import WorkflowDetails from '../WorkflowDetails';

export default function SelfStartWorkflowModal({
  show,
  workflow,
  onConfirm,
  onCancel,
  isLoading = false,
}) {
  // Handle ESC key and modal backdrop
  useEffect(() => {
    if (!show) return;

    const onKey = (e) => e.key === 'Escape' && onCancel?.();
    document.addEventListener('keydown', onKey);
    document.body.classList.add('modal-open');

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.classList.remove('modal-open');
    };
  }, [show, onCancel]);

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel?.();
      }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Start a New Task</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
              disabled={isLoading}
            />
          </div>
          <div className="modal-body">
            {workflow && <WorkflowDetails workflow={workflow} />}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Starting...' : 'Start Task'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


